import React, {PureComponent} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {
    Form,
    Input,
    notification,
    Anchor,
    Spin,
    Select,
    Tag,
    Button,
    Table,
    Card,
    Typography,
    Row,
    InputNumber,
    Col, Tooltip, Popconfirm, Checkbox, AutoComplete, Radio, Timeline, Drawer, Modal, Icon, Empty
} from 'antd'
import _ from 'lodash'
import {FormUtils as GetAllFormFields, TableComp} from 'sz-react-utils'
import moment from 'moment'


import {API_URL} from '../../../request'

import 'react-quill/dist/quill.snow.css'
import {hideLoader, showLoader} from '../../../modules/actions'
import Request from '../../../request'
import styles from '../all/styles.less'
import {connect} from 'react-redux'
import {createMatchSelector, goBack} from 'connected-react-router'
import {getUrlPushWrapper} from "../../../routes";

const FormItem = Form.Item
const {Option} = Select
const {Text, Paragraph} = Typography;
const {TextArea} = Input

@Form.create()
class AddInwardForm extends PureComponent {

    handleSubmit = e => {
        const {dispatch, form, currentUser} = this.props
        let {totalData, selectedRowKeys} = this.state

        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)

                if (values.purpose !== 'Replacement') {
                    values.replacementType = ''
                    values.replacementList = []
                }

                if (values.replacementType === 'Outward Pending') {
                    values.replacementList = []
                }

                if (totalData && totalData.length == 1) {
                    this.setState({sendLoading: false})
                    return notification.error({
                        message: 'Atleast add one product'
                    })
                }


                let foundFlag = false

                let tempArr = []
                let errorIds = []

                _.each(this.state.totalData, (item) => {

                    if (item.productIds && item.productIds.length != item.quantityAccepted) {
                        foundFlag = true
                    }
                    _.each(item.productIds, (val) => {
                        if (!tempArr.includes(val)) {
                            tempArr.push(val)

                        } else {
                            errorIds.push(val)

                        }
                    })


                })


                if (errorIds.length) {
                    return notification.error({message: `Duplicate Product Ids ${errorIds}.`})

                }
              

                totalData = _.reject(this.state.totalData, (x) => x.isLast == true)
                values.products = totalData
                values.type = 'Inward'
                values.photos = this.state.selectedPhotos.map((p) => p._id)
                dispatch(showLoader())

                let x = null
                if (this.state._id) {
                    values._id = this.state._id

                    x = await Request.updateInwardOutwardForm(values)
                } else {
                    x = await Request.addInwardOutwardForm(values)
                }

                dispatch(hideLoader())


                if (!x.error) {

                    notification.success({
                        message: this.state._id
                            ? x.message
                            : x.message
                    })

                    if (!this.state._id) {

                        this.props.form.resetFields()
                        this.props.form.setFieldsValue({date: moment(), filledBy: currentUser && currentUser._id})

                        Request.getNextInwardOutwardFormNo({type: 'Inward'}).then((data) => {
                            if (!data.error) {
                                this.props.form.setFieldsValue({
                                    serialNumber: data.data,
                                    challanNumber: `INW-${data.data}`,
                                })
                            }
                        })
                        this.setState({
                            totalData: [{isLast: true}],
                            replacementType: undefined,
                            purposeValue: undefined,
                            selectedRowKeys: [],
                            selectedPhotos: [],
                            subjectedToStock: undefined,
                            newOption: null,
                        })
                        this.loadInwardPendingList()
                    }

                    if (this.state._id) {
                        dispatch(goBack())

                    }


                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.message
                    })
                }

            }
        })
    }

    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            loader: true,
            productList: [],
            stockProductList: [], // Stock Products master — used when Subjected to Stock
            totalData: [],
            carriersData: ['Fedex', 'DHL', 'UPS', 'USPS', 'BlueDart', 'DTDC'],
            inwardPendingList: [],
            checked: true,
            newOption:null,
            selectedRowKeys: [],
            currentPage: 1,
            // ---- photo gallery picker ----
            galleryVisible: false,
            galleryLoading: false,
            galleryPhotos: [],        // available photos in the modal
            gallerySelectedIds: [],   // ids ticked inside the modal
            selectedPhotos: [],       // confirmed photos shown below the form
            previewMedia: null,       // media object shown in the lightbox

        }
        this.AddData = _.debounce(this.addData, 1000, true)


    }


    handleCancel = e => {

        this.props.form.setFieldsValue({
            quantity: null,
            productName: undefined,
        })
        this.setState({
            modalVisible: false,
            productName: '',
            quantity: ''


        })
    }


    addData = () => {


        let tt = _.cloneDeep(this.state.totalData)
        let found = _.find(tt, (i) => {
            if (i && i.isLast != true) {
                return (i.productName == this.state.productName) || (i.productName._id == this.state.productName)

            }
        })

        if (found) {
            this.setState({showText: false})
            this.props.form.setFieldsValue({
                productName: undefined,
                quantity: null,

            })

            return notification.error({
                message: 'Product Already Exists.'
            })
        }
        let comp = tt.pop()
        tt.push({

            quantityRecieved: this.state.quantityRecieved,
            quantityAccepted: this.state.quantityAccepted,
            quantityRejected: this.state.quantityRejected,
            productName: this.state.productName,
            isLast: false,
            productIds: [],
            subjectedToStock: this.state.subjectedToStock ? this.state.subjectedToStock : false,
            productId: this.state.productId

        })
        tt.push(comp)
        this.props.form.setFieldsValue({
            quantityRejected: null,
            quantityAccepted: null,
            totalData: tt,
            productName: undefined,
            quantityRecieved: null,

        })
        this.setState({
            quantityRejected: null,
            quantityAccepted: null,
            totalData: tt,
            productName: undefined,
            quantityRecieved: null,
            subjectedToStock: undefined,
            productId: null

        }, () => {

        })

    }
    handleProductSearch = async (test) => {
        if (test == '' || test == undefined) {
            this.setState({productList: this.state.productList})

            return false
        } else {
            let tt = _.cloneDeep(this.state.totalData)

            this.setState({
                quantityRejected: 0,
                quantityAccepted: 1,
                totalData: tt,
                productName: test,
                quantityRecieved: 1,


            }, () => {
                this.addData()
            })
        }


    }

    onProductSelect = (val) => {
        // Subjected to Stock => the picked value is a real Stock Product _id.
        // Store its readable name (for the table) and its real id (for the stock
        // ledger), instead of the free product-name string.
        if (this.state.subjectedToStock) {
            const sp = (this.state.stockProductList || []).find((o) => String(o._id) === String(val))
            if (sp) {
                this.props.form.setFieldsValue({productName: sp._id})
                this.setState({
                    productName: sp.name,
                    productId: sp._id,
                    quantityRejected: 0,
                    quantityAccepted: 1,
                    quantityRecieved: 1,
                }, () => {
                    this.addData()
                })
                return
            }
        }

        // Not subjected to stock — free history products (name is used as _id)
        let selectedQuote = this.state.productList.find((obj) => obj._id === val)
        if (selectedQuote) {
            this.props.form.setFieldsValue({
                productName: selectedQuote._id,

            })
            this.setState({
                quantityRejected: 0,
                quantityAccepted: 1,
                productName: selectedQuote._id,
                quantityRecieved: 1

            }, () => {
                this.addData()
            })
        }
        else{
            this.handleProductSearch(val)
        }

    }
    showDrawer = () => {
        this.setState({
            visible: true,
            key: Date.now()
        })
    }

    getOptionsData = async () => {
        let currentUser = JSON.parse(window.localStorage.getItem('user'))

        let filter = {
            userType: {$in: ['Admin', 'RO', 'Dispatch', 'Technician', 'Lead Executive', 'Caller']},
            results: 10000
        }
        this.props.form.setFieldsValue({
            filledBy: currentUser._id
        })

        Request.getAllHistoryProducts({
            results: 2000
        }).then((data) => {
            this.setState({productList: data || []}, () => {

            })
        })
        // Stock Products master (the "All Stock Products" list) — shown in the
        // Product dropdown when a row is marked Subjected to Stock
        Request.getAllStockProducts({results: 2000, regExFilters: ['name']}).then((res) => {
            const list = !res ? [] : Array.isArray(res) ? res : res.data || res.products || []
            this.setState({stockProductList: list})
        })
        Request.loadUser(filter).then(({data: userList}) => {

            this.setState({userList: userList || []})
        })


    }
    loadInwardPendingList = async () => {

        Request.inwardOutwardListDispatch({
            replacementType: 'Inward Pending',
            purpose: 'Replacement',
            results: 100000000000000000
        }).then(({data}) => {

            this.setState({inwardPendingList: data || []})
        })

    }

    async componentDidMount() {
        let searchParams = new URLSearchParams(this.props.search);
        let dispatchId = searchParams.get('id')

        this.getOptionsData()

        if (dispatchId) {

            Request.getDispatchInwardOutwardById({_id: dispatchId}).then(({data: dispatchData, error, message}) => {
                if (!error) {
                    let selectedInwards = _.map(dispatchData.replacementList, (ii) => {
                        return ii._id
                    })

                    const mappedPhotos = _.map(dispatchData.photos || [], (p) => ({
                        _id: p._id,
                        url: p.url || p.imageUrl,
                        path: p.path,
                        type: p.type || (p.mediaType === 'video' ? 'video' : 'image'),
                        subCategory: p.subCategory || p.subcategory,
                        orderId: p.orderId,
                        userName: p.userName || p.uploaderName,
                        remarks: p.remarks,
                    }))

                    this.setState({
                        _id: dispatchData && dispatchData._id,
                        loader: false,
                        totalData: [...dispatchData.products, {isLast: true}],
                        replacementType: dispatchData.replacementType,
                        purposeValue: dispatchData && dispatchData.purpose,
                        selectedRowKeys: selectedInwards,
                        inwardPendingList: dispatchData.replacementList,
                        selectedPhotos: mappedPhotos

                    })
                    this.props.form.setFieldsValue({

                        serialNumber: dispatchData && dispatchData.serialNumber,
                        productType: dispatchData && dispatchData.productType,
                        challanNumber: dispatchData && dispatchData.challanNumber,
                        filledBy: dispatchData && dispatchData.filledBy,
                        checkedBy: dispatchData && dispatchData.checkedBy,
                        countedBy: dispatchData && dispatchData.countedBy,
                        qcCheckedBy: dispatchData && dispatchData.qcCheckedBy,
                        // Sender field is bound to `consignee` — was missing here,
                        // so it never populated on edit
                        consignee: dispatchData && dispatchData.consignee,
                        date: dispatchData && moment(dispatchData.date),
                        purpose: dispatchData && dispatchData.purpose,
                        replacementType: dispatchData.replacementType,
                        replacementList: dispatchData.replacementList

                    });
                } else {
                    this.setState({
                        loader: false
                    })
                    notification.error({
                        message: 'Error Getting Data'
                    })
                }
            })
        } else {
            Request.getNextInwardOutwardFormNo({type: 'Inward'}).then((data) => {
                if (!data.error) {
                    this.props.form.setFieldsValue({
                        serialNumber: data.data,
                        challanNumber: `INW-${data.data}`,
                        date: moment(),
                    })
                }
            })
            this.loadInwardPendingList()
            this.setState({loader: false})
            this.state.totalData.push({isLast: true})

        }


    }


    // ---- Photo gallery picker ----
    openGallery = () => {
        const {_id, selectedPhotos} = this.state
        this.setState({
            galleryVisible: true,
            galleryLoading: true,
            gallerySelectedIds: selectedPhotos.map((p) => p._id),
        })
        Request.inwardGalleryPhotos(_id ? {inwardId: _id} : {}).then(({data, error}) => {
            this.setState({
                galleryLoading: false,
                galleryPhotos: (!error && data) ? data : [],
            })
        })
    }

    toggleGalleryPhoto = (id) => {
        this.setState((s) => {
            const exists = s.gallerySelectedIds.includes(id)
            return {
                gallerySelectedIds: exists
                    ? s.gallerySelectedIds.filter((x) => x !== id)
                    : [...s.gallerySelectedIds, id],
            }
        })
    }

    confirmGallery = () => {
        const {galleryPhotos, gallerySelectedIds, selectedPhotos} = this.state
        // keep already-selected photo objects that may not be in the current
        // gallery list, then add the freshly ticked ones
        const byId = {}
        selectedPhotos.forEach((p) => { byId[p._id] = p })
        galleryPhotos.forEach((p) => { byId[p._id] = p })
        const chosen = gallerySelectedIds.map((id) => byId[id]).filter(Boolean)
        this.setState({selectedPhotos: chosen, galleryVisible: false})
    }

    removeSelectedPhoto = (id) => {
        this.setState((s) => ({
            selectedPhotos: s.selectedPhotos.filter((p) => p._id !== id),
        }))
    }

    openPreview = (media) => this.setState({previewMedia: media})
    closePreview = () => this.setState({previewMedia: null})

    render() {
        const {
            form,
            form: {getFieldDecorator, getFieldValue}
        } = this.props

        const {
            productList,
            _id,
            userList,
            isDispatch,
            newUserList,
            carriersData,
            purposeValue,
            replacementType,
            selectedRowKeys,
            inwardPendingList,
            singleRecord
        } = this.state

        const inputTypes = {
            fields: [
                {
                    label: 'Serial No.',
                    key: 'serialNumber',
                    customProps: {disabled: true},
                    required: true,

                },
                {
                    label: 'Date',
                    key: 'date',
                    type: 'date',

                },
                {
                    label: 'Product Type',
                    key: 'productType',
                    type: 'select',
                    options: ['Finish Goods', 'Consumable', 'Electronic Components', 'Raw Material'],
                    onChange: productType => {
                        this.props.form.setFieldsValue({
                            productType: productType
                        })

                    }


                },

                {
                    label: 'Purpose',
                    key: 'purpose',
                    type: 'select',
                    options: ['Repair', 'Purchase', 'Replacement'],
                    onChange: async (purpose) => {
                        this.setState({purposeValue: purpose, replacementType: undefined})
                        this.props.form.setFieldsValue({
                            purpose: purpose
                        })
                    }


                },
                {
                    label: 'Sender',
                    key: 'consignee',


                },
            ]
        }
        const inputTypes1 = {
            fields: [
                {
                    label: 'Challan Number',
                    key: 'challanNumber',

                },
                {
                    label: 'Filled By',
                    key: 'filledBy',
                    showSearch: true,
                    disabled: true,
                    keyAccessor: x => x._id,
                    valueAccessor: x => `${x.name} ${x.mobile} (${x.userType})`,
                    type: 'select',
                    options: userList || [],
                    onChange: filledBy => {
                        this.props.form.setFieldsValue({
                            filledBy: filledBy
                        })

                    },

                },
                {
                    label: 'Checked By',
                    key: 'checkedBy',
                },
                {
                    label: 'Counted By',
                    key: 'countedBy',
                },
                {
                    label: 'QC Checked By',
                    key: 'qcCheckedBy',
                },

            ]
        }

        const refColumns = [

            {
                title: 'S.No',
                dataIndex: 'sno',
                key: 'sno',
                width: 70,
                render: (value, item, index) => {
                    if (item && item.isLast != true) {
                        return index + 1
                    }
                }
            }, {
                title: 'Subjected to Stock',
                dataIndex: 'subjectedToStock',
                key: 'subjectedToStock',
                width: 150,
                render: (value, item, index) => {
                    if (item && item.isLast == true) {
                        return <Checkbox
                            checked={!!this.state.subjectedToStock}
                            onChange={(val) => {
                                this.setState({subjectedToStock: val.target.checked})
                            }}/>
                    } else {
                        return <Tag>{value ? 'Yes' : 'No'}</Tag>
                    }
                }
            },

            {
                title: 'Product',
                dataIndex: 'productName',
                key: 'productName',
                width: 200,
                render: (x, item, index) => {
                    if (item && item.isLast == true) {
                        // When "Subjected to Stock" is checked, list the Stock
                        // Products master (real _id + name); otherwise list the free
                        // history products (name is used as _id). Options are filtered
                        // by what's typed and capped so the dropdown stays fast.
                        const useStock = !!this.state.subjectedToStock
                        const stockList = this.state.stockProductList || []
                        const search = (this.state.newOption || '').toLowerCase().trim()
                        const productOptions = useStock
                            ? (search
                                ? stockList.filter((v) => String(v.name || '').toLowerCase().indexOf(search) !== -1)
                                : stockList
                              ).slice(0, 50)
                            : (search
                                ? productList.filter((v) => String(v._id).toLowerCase().indexOf(search) !== -1)
                                : productList
                              ).slice(0, 50)

                        return (<div>
                            {getFieldDecorator('productName', {})(
                                 <AutoComplete
                                    notFoundContent={this.state.showSpin && <Spin/>}
                                    autoComplete={'none'}
                                    dropdownMatchSelectWidth={false}
                                    optionFilterProp={'children'}
                                    filterOption={false}
                                    onSelect={this.onProductSelect}
                                    placeholder={useStock ? 'Select stock product' : 'Product Name'}
                                    onSearch={(val) => {
                                        this.setState({newOption: val})
                                    }}
                                >
                                {/* free-text add is only for non-stock products */}
                                {!useStock && this.state.newOption &&
                                        <Option value={this.state.newOption || ''}>{this.state.newOption}</Option>}
                                {productOptions.map((val) => (
                                    <Option key={val._id} value={val._id}>
                                        {useStock ? val.name : <div><b>{val._id}</b></div>}
                                    </Option>
                                ))}

                                </AutoComplete>)}

                        </div>)

                    } else {
                        return <div style={{marginBottom: '5px'}}> {x}</div>
                    }


                }


            },
            {
                title: 'ProductIds',
                key: 'productIds',
                dataIndex: 'productIds',
                render: (x, item, key) => {
                    if (item && item.isLast !== true) {
                        return <div>
                            <Select
                                defaultValue={item && item.productIds}
                                style={{width: 200}}
                                placeholder={'Enter Product Id'}
                                mode={'tags'}
                                onChange={(e) => {
                                    let array = []
                                    _.each(e, (i) => {
                                        array.push(i.toLowerCase())
                                    })
                                    item.productIds = array


                                }}
                            >
                            </Select>
                        </div>
                    }
                }


            },


            {
                title: 'Quantity Recieved',
                key: 'quantityRecieved',
                dataIndex: 'quantityRecieved',
                render: (y, item, index) => {
                    if (item && item.isLast != true) {
                        // controlled input + immutable update (the old antd
                        // `Text editable` cell mutated state in place and caused
                        // the cell to flicker). Changing received resets accepted
                        // to the same value (rejected -> 0), as before.
                        return (
                            <InputNumber
                                min={0}
                                value={item.quantityRecieved}
                                style={{width: 90}}
                                onChange={(val) => {
                                    const v = val == null ? 0 : Math.abs(val)
                                    const tt = this.state.totalData.slice()
                                    tt[index] = {
                                        ...tt[index],
                                        quantityRecieved: v,
                                        quantityAccepted: v,
                                        quantityRejected: 0,
                                    }
                                    this.setState({totalData: tt})
                                }}
                            />
                        )
                    }


                }

            },
            {
                title: 'Quantity Accepted',
                key: 'quantityAccepted',
                dataIndex: 'quantityAccepted',
                render: (y, item, index) => {
                    if (item && item.isLast != true) {
                        // controlled input + immutable update; accepted is clamped
                        // to received and rejected is kept = received - accepted.
                        return (
                            <InputNumber
                                min={0}
                                max={item.quantityRecieved}
                                value={item.quantityAccepted}
                                style={{width: 90}}
                                onChange={(val) => {
                                    const received = Number(this.state.totalData[index].quantityRecieved) || 0
                                    let v = val == null ? 0 : Math.abs(val)
                                    if (v > received) v = received
                                    const tt = this.state.totalData.slice()
                                    tt[index] = {
                                        ...tt[index],
                                        quantityAccepted: v,
                                        quantityRejected: received - v,
                                    }
                                    this.setState({totalData: tt})
                                }}
                            />
                        )
                    }


                }

            },
            {
                title: 'Quantity Rejected',
                key: 'quantityRejected',
                dataIndex: 'quantityRejected',
                render: (y, item, index) => {
                    if (item && item.isLast != true) {
                        return y

                    }


                }

            },


            {
                title: 'Action',
                key: 'operation',
                width: 80,
                render: (item, record) => {
                    if (record && record.isLast != true) {
                        return <React.Fragment>

                            <Tooltip title="Delete Product">
                                <Popconfirm
                                    title="Are you sure delete this Product?"
                                    onConfirm={() => {
                                        let tt = this.state.totalData
                                        tt = _.reject(tt, item)
                                        this.setState({totalData: tt}, () => {
                                        })


                                    }}
                                    onCancel={() => {
                                    }}
                                    okText="Yes"
                                    cancelText="No">
                                    <Button
                                        shape="circle"
                                        size="small"
                                        type={'danger'}
                                        icon="delete"
                                    />
                                </Popconfirm>

                            </Tooltip>

                        </React.Fragment>

                    }
                }
            }
        ]
        const column = [
            {
                title: 'Id',
                dataIndex: 'serialNumber',
                width: 80,
                fixed: 'left',
                key: 'serialNumber',
                searchTextName: 'serialNumber'

            },
            {
                title: 'Type',
                dataIndex: 'type',
                key: 'type',
                width: 110,
                fixed: 'left',
                render: (val) => {
                    return <Tag color={val === 'Inward' ? 'blue' : 'red'}>{val}</Tag>
                }

            },
            {
                title: 'Products',
                dataIndex: 'products',
                key: 'products',
                width: 200,
                render: (val, record, index) => {
                    return <React.Fragment>
                        <div>
                            <ul style={{paddingLeft: '0px', listStyle: 'none'}}>
                                {val && val.length && val.map((item, key) => {

                                    return <li key={key}>{item.productName}</li>
                                })}

                            </ul>

                        </div>
                    </React.Fragment>

                }

            },
            {
                title: 'Purpose',
                dataIndex: 'purpose',
                width: 120,
                key: 'purpose',

            },
            {
                title: 'Challan Number',
                dataIndex: 'challanNumber',
                width: 150,
                key: 'challanNumber',
                searchTextName: 'challanNumber',
            },
            {
                title: 'Invoice Number',
                dataIndex: 'invoiceNumber',
                width: 150,
                key: 'invoiceNumber',
                searchTextName: 'invoiceNumber',
            },
            {
                title: 'Order Authority',
                dataIndex: 'orderAuthority',
                width: 150,
                key: 'orderAuthority',
                render: (val, record) => {
                    return (<div>
                        <div>{record.orderAuthority ? record.orderAuthority.name : ''}</div>
                    </div>)
                }
            },


            {
                title: 'Consignee Name',
                dataIndex: 'consignee',
                width: 150,
                key: 'consignee',
                searchTextName: 'consignee'
            },
            {
                title: 'Packing Done By',
                width: 150,
                dataIndex: 'packingDoneBy',
                key: 'packingDoneBy',
                searchTextName: 'packingDoneBy'

            },

            {
                title: 'Date',
                dataIndex: 'date',
                key: 'date',
                width: 180,
                searchDateName: 'date',
                render: (text, record) => {
                    return (
                        <Tag>
                            {text ? moment(text).format('lll') : ''}
                        </Tag>
                    )
                },
            },
            {
                title: 'Created At',
                dataIndex: 'createdAt',
                key: 'createdAt',
                width: 180,
                searchDateName: 'createdAt',
                render: (text, record) => {
                    return (
                        <Tag>
                            {text ? moment(text).format('lll') : ''}
                        </Tag>
                    )
                },
            },
            {
                key: 'actions',
                title: 'Actions',
                fixed: 'right',
                width: 80,
                render: (val, record, key) => {
                    return (<React.Fragment>
                        <Tooltip title="View Products">
                            <Button
                                style={{marginRight: '6px', marginTop: '6px'}}
                                size="small"
                                shape="circle"
                                onClick={() => {
                                    this.setState({
                                        singleRecord: record
                                    }, () => {
                                        this.showDrawer()

                                    })

                                }}
                                icon="eye"
                            />
                        </Tooltip>
                    </React.Fragment>)
                }
            }

        ]


        const rowSelection = {
            selectedRowKeys: selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState({selectedRowKeys})
                this.props.form.setFieldsValue({replacementList: selectedRows})
            },
            getCheckboxProps: record => ({
                _id: record._id
            })
        }

        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                sm: {span: 8},
                md: {span: 8}
            },
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 16},
                md: {span: 12}
            }
        }

        return (
            <PageHeaderWrapper title={this.state._id ? 'Update Inward Form' : 'Add Inward Form'}
            >

                <Spin spinning={this.state.loader}>
                    <Form onSubmit={this.handleSubmit} hideRequiredMark={false} style={{marginTop: 8}}>

                        <Card bordered={true}>

                            {/* ---- Inward Photo Gallery ---- */}
                            <Row>
                                <Col span={24} style={{marginBottom: '24px'}}>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        marginBottom: '12px'
                                    }}>
                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                            <Text strong>Inward Photos</Text>
                                            <Tag color="blue" style={{marginLeft: 8}}>
                                                {this.state.selectedPhotos.length}
                                            </Tag>
                                        </div>
                                        <Button icon="picture" onClick={this.openGallery}>
                                            Select Photos
                                        </Button>
                                    </div>

                                    {this.state.selectedPhotos.length ? (
                                        <div style={{display: 'flex', flexWrap: 'wrap', gap: '12px'}}>
                                            {this.state.selectedPhotos.map((p) => (
                                                <div key={p._id} style={{
                                                    position: 'relative',
                                                    width: 110,
                                                    height: 90,
                                                    borderRadius: 6,
                                                    overflow: 'hidden',
                                                    background: '#000',
                                                    border: '1px solid #e8e8e8'
                                                }}>
                                                    {p.type === 'video' ? (
                                                        <video src={p.url} style={{width: '100%', height: '100%', objectFit: 'cover'}}/>
                                                    ) : (
                                                        <img src={p.url} alt="" style={{width: '100%', height: '100%', objectFit: 'cover'}}/>
                                                    )}
                                                    <Tooltip title="Preview">
                                                        <div
                                                            onClick={() => this.openPreview(p)}
                                                            style={{
                                                                position: 'absolute',
                                                                top: 4,
                                                                left: 4,
                                                                width: 22,
                                                                height: 22,
                                                                borderRadius: '50%',
                                                                background: 'rgba(0,0,0,0.6)',
                                                                color: '#fff',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                cursor: 'pointer'
                                                            }}>
                                                            <Icon type={p.type === 'video' ? 'play-circle' : 'eye'}/>
                                                        </div>
                                                    </Tooltip>
                                                    <Tooltip title="Remove">
                                                        <div
                                                            onClick={() => this.removeSelectedPhoto(p._id)}
                                                            style={{
                                                                position: 'absolute',
                                                                top: 4,
                                                                right: 4,
                                                                width: 22,
                                                                height: 22,
                                                                borderRadius: '50%',
                                                                background: 'rgba(255,0,0,0.75)',
                                                                color: '#fff',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                cursor: 'pointer'
                                                            }}>
                                                            <Icon type="close"/>
                                                        </div>
                                                    </Tooltip>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div style={{
                                            border: '1px dashed #d9d9d9',
                                            borderRadius: 6,
                                            padding: '16px',
                                            textAlign: 'center',
                                            color: '#999'
                                        }}>
                                            No photos selected. Click "Select Photos" to pick from the Inward gallery.
                                        </div>
                                    )}
                                </Col>
                            </Row>

                            <Row>
                                <Col span={12}>
                                    <GetAllFormFields apiurl={API_URL}
                                                      inputSchema={inputTypes}
                                                      formItemLayout={formItemLayout}
                                                      getFieldDecorator={getFieldDecorator}/>


                                    {(purposeValue == 'Replacement') ?
                                        <Form.Item label={'Replacement Type'} {...formItemLayout}>
                                            {getFieldDecorator('replacementType', {})(
                                                <Radio.Group disabled={this.state._id ? true : false}
                                                             options={['Outward Pending', 'Already Outward']}
                                                             className={styles.inwardRadioButton}
                                                             onChange={(checkedValues) => {
                                                                 this.setState({replacementType: checkedValues.target.value})
                                                             }} value={this.state.replacementType}>


                                                </Radio.Group>
                                            )}
                                        </Form.Item> : ''}


                                </Col>
                                <Col span={12}>
                                    <GetAllFormFields apiurl={API_URL}
                                                      inputSchema={inputTypes1}
                                                      formItemLayout={formItemLayout}
                                                      getFieldDecorator={getFieldDecorator}/>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {(replacementType === 'Already Outward') ?
                                        <Form.Item label={'Inward Pending'}>

                                            {getFieldDecorator('replacementList', {})(<Table
                                                    bordered={true}
                                                    rowKey={x => x._id}
                                                    columns={column}
                                                    scroll={{y: 350, x: 'max-content'}}
                                                    dataSource={inwardPendingList || []}
                                                    pagination={false}
                                                    rowSelection={this.state._id ? '' : rowSelection}
                                                />
                                            )}
                                        </Form.Item> : ''}
                                </Col>
                            </Row>

                            <Row>
                                <Col span={24} style={{marginTop: '20px'}}>
                                    {<Table
                                        bordered={true}
                                        rowKey={(x, i) => (x && x.isLast) ? 'add-row' : String((x && (x.productId || x._id)) || i)}
                                        columns={refColumns}
                                        dataSource={this.state.totalData || []}
                                        pagination={false}
                                    />}

                                </Col>
                            </Row>

                            <Form.Item style={{marginTop: 32, textAlign: 'center'}}>

                                <Button size="large" type='primary'
                                        loading={this.props.loading}
                                        htmlType='submit'
                                        style={{width: '15%', marginLeft: '1em'}}>{_id ? `Update` : `Save`}
                                </Button>


                            </Form.Item>
                        </Card>


                    </Form>
                    <Drawer
                        title=""
                        placement="right"
                        closable={true}
                        onClose={() => {
                            this.setState({
                                visible: false,
                            })
                        }}
                        visible={this.state.visible}
                        width={600}>
                        <Card className={styles.drawerCard}>

                            <table style={{width: '100%'}} className={styles.ProcessTable}>
                                <thead>
                                <tr>
                                    <th>Product Name</th>
                                    <th>Quantity</th>
                                    <th>Product Ids</th>
                                </tr>
                                </thead>

                                <tbody> {_.map(singleRecord && singleRecord.products, (item) => {
                                    return <tr>
                                        <td colSpan="1">{item && item.productName}</td>
                                        <td colSpan="1">{item && item.quantity}</td>
                                        <td>
                                            {item && item.productIds.join(' , ')}
                                        </td>

                                    </tr>

                                })}</tbody>


                            </table>

                        </Card>

                    </Drawer>

                    {/* ---- Inward Photo Gallery picker ---- */}
                    <Modal
                        title="Select Inward Photos"
                        visible={this.state.galleryVisible}
                        onCancel={() => this.setState({galleryVisible: false})}
                        onOk={this.confirmGallery}
                        okText={`Add Selected (${this.state.gallerySelectedIds.length})`}
                        width={900}
                        destroyOnClose>
                        <Spin spinning={this.state.galleryLoading}>
                            {this.state.galleryPhotos.length ? (
                                <div style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: '12px',
                                    maxHeight: '60vh',
                                    overflowY: 'auto'
                                }}>
                                    {this.state.galleryPhotos.map((p) => {
                                        const selected = this.state.gallerySelectedIds.includes(p._id)
                                        // status-driven border: approved=green, rejected=red, pending=neutral
                                        const statusColor = p.status === 'Completed'
                                            ? '#52c41a'
                                            : p.status === 'Rejected'
                                                ? '#f5222d'
                                                : '#e8e8e8'
                                        return (
                                            <div key={p._id}
                                                 onClick={() => this.toggleGalleryPhoto(p._id)}
                                                 style={{
                                                     position: 'relative',
                                                     width: 150,
                                                     height: 120,
                                                     borderRadius: 6,
                                                     overflow: 'hidden',
                                                     cursor: 'pointer',
                                                     background: '#000',
                                                     border: `${selected ? 4 : 3}px solid ${statusColor}`
                                                 }}>
                                                {p.type === 'video' ? (
                                                    <video src={p.url} style={{width: '100%', height: '100%', objectFit: 'cover'}}/>
                                                ) : (
                                                    <img src={p.url} alt="" style={{width: '100%', height: '100%', objectFit: 'cover'}}/>
                                                )}
                                                <Tooltip title="Preview">
                                                    <div
                                                        onClick={(e) => { e.stopPropagation(); this.openPreview(p) }}
                                                        style={{
                                                            position: 'absolute',
                                                            top: 4,
                                                            left: 4,
                                                            width: 24,
                                                            height: 24,
                                                            borderRadius: '50%',
                                                            background: 'rgba(0,0,0,0.6)',
                                                            color: '#fff',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}>
                                                        <Icon type={p.type === 'video' ? 'play-circle' : 'eye'}/>
                                                    </div>
                                                </Tooltip>
                                                {selected && (
                                                    <div style={{
                                                        position: 'absolute',
                                                        top: 4,
                                                        right: 4,
                                                        width: 24,
                                                        height: 24,
                                                        borderRadius: '50%',
                                                        background: '#1890ff',
                                                        color: '#fff',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <Icon type="check"/>
                                                    </div>
                                                )}
                                                <div style={{
                                                    position: 'absolute',
                                                    bottom: 0,
                                                    left: 0,
                                                    right: 0,
                                                    padding: '2px 6px',
                                                    fontSize: 11,
                                                    color: '#fff',
                                                    background: 'rgba(0,0,0,0.55)',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis'
                                                }}>
                                                    {p.orderId ? `#${p.orderId} · ` : ''}{p.userName || ''}
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            ) : (
                                !this.state.galleryLoading && (
                                    <Empty description="No unassigned Inward photos available"/>
                                )
                            )}
                        </Spin>
                    </Modal>

                    {/* ---- Media preview lightbox ---- */}
                    <Modal
                        visible={!!this.state.previewMedia}
                        onCancel={this.closePreview}
                        footer={null}
                        width={800}
                        bodyStyle={{padding: 0, background: '#000', textAlign: 'center'}}
                        destroyOnClose>
                        {this.state.previewMedia && (
                            this.state.previewMedia.type === 'video' ? (
                                <video
                                    src={this.state.previewMedia.url}
                                    controls
                                    autoPlay
                                    style={{width: '100%', maxHeight: '80vh'}}
                                />
                            ) : (
                                <img
                                    src={this.state.previewMedia.url}
                                    alt=""
                                    style={{width: '100%', maxHeight: '80vh', objectFit: 'contain'}}
                                />
                            )
                        )}
                    </Modal>

                </Spin>


            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    currentUser: global.currentUser

})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddInwardForm)
